import { Injectable, OnInit } from '@angular/core';
import { LocalStoreService } from '../local-store.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { map, catchError, delay, tap, distinctUntilChanged } from 'rxjs/operators';
import { User } from '../../models/user.model';
import { of, BehaviorSubject, throwError, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import {Empresa} from '../../interfaces/empresa';
import { Filial } from '../../interfaces/filial';
import { Item } from '../../interfaces/item';
import { Cadastro } from '../../interfaces/cadastro';
import { Loja } from '../../interfaces/loja';
import { Token } from '../../interfaces/token'
import { LoginRequest } from 'app/shared/interfaces/login-request';
import { Usuario } from '../../interfaces/usuario';
import { PageResult } from 'app/shared/interfaces/page-result';

// ================= only for demo purpose ===========
const DEMO_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YjhkNDc4MDc4NmM3MjE3MjBkYzU1NzMiLCJlbWFpbCI6InJhZmkuYm9ncmFAZ21haWwuY29tIiwicm9sZSI6IlNBIiwiYWN0aXZlIjp0cnVlLCJpYXQiOjE1ODc3MTc2NTgsImV4cCI6MTU4ODMyMjQ1OH0.dXw0ySun5ex98dOzTEk0lkmXJvxg3Qgz4ed';


// ================= you will get those data from server =======

@Injectable({
  providedIn: 'root',
})export class JwtAuthService implements OnInit {

  token;
  tokenRemoto;
  isAuthenticated: Boolean;
  item: Item;
  // item$: BehaviorSubject<Item> ;
  // itemRemoto$:  BehaviorSubject<Item>;
  // filial$:  BehaviorSubject<Filial>;
  // user$:  BehaviorSubject<Usuario>;
  itemRemoto: Item;

  user: Usuario;
  filial: Filial;
  signingIn: Boolean;
  return: string;
  JWT_TOKEN = 'JWT_TOKEN';
  JWT_TOKEN_REMOTO = 'JWT_TOKEN_REMOTO';
  APP_USER = 'KAW_USER';
  URL_API = 'URL_API';
  IMPORTA_DEFAULTS = 'IMPORTA_DEFAULTS';

  readonly url = `${environment.apiURL}`;

  readonly path = `/usuario`;

  readonly authPath = `/auth`;

  public apiUrl = null;

  public subjApiUrl$: BehaviorSubject<String> = new BehaviorSubject(environment.apiURL);

  private subjUsuario$: BehaviorSubject<Usuario> = new BehaviorSubject(null);
  private subjCadastro$: BehaviorSubject<Cadastro> = new BehaviorSubject(null);
  private subjLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private subjEmpresaSelecionada$: BehaviorSubject<Loja> = new BehaviorSubject(null);
  private subjItemLoja$: BehaviorSubject<Item> = new BehaviorSubject(null);

  private readonly ITEM_REMOTO_KEY = 'ITEM_REMOTO';

  public item$: BehaviorSubject<Item>;
  public itemRemoto$: BehaviorSubject<Item>;
  public user$: BehaviorSubject<Usuario>;
  public filial$: BehaviorSubject<Filial>;

  constructor(
    private ls: LocalStoreService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {
    // this.item$  = new BehaviorSubject<Item>(this.item);
    // this.itemRemoto$ = (new BehaviorSubject<Item>(this.itemRemoto));
    // this.user$ = (new BehaviorSubject<Usuario>(this.user));
    // this.filial$ = (new BehaviorSubject<Filial>(this.filial));

    this.item$ = new BehaviorSubject<Item>(this.ls.getItem('ITEM') || null);
    this.itemRemoto$ = new BehaviorSubject<Item>(this.ls.getItem(this.ITEM_REMOTO_KEY) || null);
    this.user$ = new BehaviorSubject<Usuario>(this.ls.getItem('USER') || null);
    this.filial$ = new BehaviorSubject<Filial>(this.ls.getItem('FILIAL') || null);


    this.route.queryParams.subscribe(params => this.return = params['return'] || '/dashboard/main');

    this.item$.pipe(distinctUntilChanged()).subscribe(item => {
      if (this.getUrlApi()) {
        this.apiUrl = this.getUrlApi();
      }
    });

    this.itemRemoto$.pipe(distinctUntilChanged()).subscribe(itemRemoto => {
      if (itemRemoto) {
        this.ls.setItem(this.ITEM_REMOTO_KEY, itemRemoto);
      } else {
        this.ls.removeItem(this.ITEM_REMOTO_KEY);
      }
    });

    // this.item$?.pipe(distinctUntilChanged()).subscribe(item => {
    //   if (this.getUrlApi()) {
    //     this.apiUrl = this.getUrlApi();
    //   }
    //   console.log('ITEM MUDADO URL:' + this.apiUrl);
    // });
    // this.item$.pipe(distinctUntilChanged()).subscribe(item => {
    //   if (this.getUrlApi()) {
    //     this.apiUrl = this.getUrlApi();
    //   }
    //   console.log('ITEM MUDADO URL:' + this.apiUrl);

    //   if (this.itemRemoto) {
    //     const updatedItem = { ...item, cadastroVendedorId: this.itemRemoto.cadastroVendedorId };
    //     this.item$.next(updatedItem);
    //   }
    // });
  }


  // Método para atualizar itemRemoto
  updateItemRemoto(itemRemoto: Item) {
    this.itemRemoto$.next(itemRemoto);
  }

  ngOnInit(): void {

  }


  signin(username: string, password: string, captcha: string): Observable<Token> {
    this.signout(false);
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    return this.http
      .post<Token>(
        `${environment.apiURL}/auth/signin`,
        { username, password, captcha }, 
        { headers }
      )
      .pipe(
        tap((i: Token) => {
          this.item = i.item;
          this.item$?.next(i.item);
          this.setUserAndToken(i.item, !!i.item.usuario, i.itemRemoto);
        })
      );
  }
 

  signUp( signup: any): Observable<Token> {
    return this.http.put<Token>(`${environment.apiURL}/auth/signup`, signup)
    .pipe(
      tap((i: Token) => {
        // console.log('usuário:' + JSON.stringify(i));
        this.setUserAndToken(i.item, !!i.item.usuario, i.itemRemoto);
      })
      );
  }

  isLocalHost(): boolean {
    return this.url.search('localhost') > -1 ;
  }

  // public signin(username, password) {
  //   return of({token: DEMO_TOKEN, user: DEMO_USER})
  //     .pipe(
  //       delay(1000),
  //       map((res: any) => {
  //         this.setUserAndToken(res.token, res.user, !!res);
  //         this.signingIn = false;
  //         return res;
  //       }),
  //       catchError((error) => {
  //         return throwError(error);
  //       })
  //     );

    // FOLLOWING CODE SENDS SIGNIN REQUEST TO SERVER

    // this.signingIn = true;
    // return this.http.post(`${environment.apiURL}/auth/local`, { username, password })
    //   .pipe(
    //     map((res: any) => {
    //       this.setUserAndToken(res.token, res.user, !!res);
    //       this.signingIn = false;
    //       return res;
    //     }),
    //     catchError((error) => {
    //       return throwError(error);
    //     })
    //   );
  // }

  /*
    checkTokenIsValid is called inside constructor of
    shared/components/layouts/admin-layout/admin-layout.component.ts
  */
  // public checkTokenIsValid() {
  //   return of(DEMO_USER)
  //     .pipe(
  //       map((profile: Usuario) => {
  //         this.setUserAndToken(this.getJwtToken(), profile, true);
  //         this.signingIn = false;
  //         return profile;
  //       }),
  //       catchError((error) => {
  //         return of(error);
  //       })
  //     );



    /*
      The following code get user data and jwt token is assigned to
      Request header using token.interceptor
      This checks if the existing token is valid when app is reloaded
    */

    // return this.http.get(`${environment.apiURL}/api/users/profile`)
    //   .pipe(
    //     map((profile: User) => {
    //       this.setUserAndToken(this.getJwtToken(), profile, true);
    //       return profile;
    //     }),
    //     catchError((error) => {
    //       this.signout();
    //       return of(error);
    //     })
    //   );
  // }

  public checkTokenIsValid() {
    return this.http
      .get<Token>(`${environment.apiURL}/auth/me`)
      .pipe(
        map((u: Token) => {
          if (u) {
            this.setUserAndToken(u.item, true, this.itemRemoto);
            return this.http
            .get<Filial>(`${environment.apiURL}/auth/me/filial`).subscribe(fil => {
              this.filial = fil;
              this.filial$?.next(fil);
            });
           return u.item.usuario;
          }
        }),
        catchError((err) => {
          this.signout();
          return of(err);
        })
      );
  }

  public validEmail(token: String, email: String) {
    return this.http
      .get<Boolean>(`${environment.apiURL}/auth/email/confirma?email=${email}&token=${token}`);
  }

  public getEmpresaList(): Observable<Empresa[]> {
    return this.http
            .get<Empresa[]>(`${environment.apiURL}/auth/me/empresa/list`);
  }

  getEmpresaPage(page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<Empresa>> {
    return this.http.get<PageResult<Empresa>>(`${environment.apiURL}/auth/me/empresa/page/get/?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction ?? 'ASC'}`);
  }

  getEmpresaPageSearch(page?: number, size?: number, search?: string, order?: string, direction?: string): Observable<PageResult<Empresa>> {
    return this.http.get<PageResult<Empresa>>(`${environment.apiURL}/auth/me/empresa/page/get/?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction ?? 'ASC'}`);
  }



  public getAuthNames(): Observable<string[]> {
    return this.http
            .get<string[]>(`${this.apiUrl}/role/names`);
  }

  public getAuthValues(): Observable<string[]> {
    return this.http
            .get<string[]>(`${this.apiUrl}/role/names/auth`);
  }

  public selecionaFilial(empresa: Empresa) {
    return this.http
            .put(`${environment.apiURL}/auth/me/empresa/select/${empresa.codigo}`, null );
  }

  signinConfirm(password): Observable<Token> {
    return this.http
      .post<Token>(`${environment.apiURL}/confirm/signin`, {password: password});
  }

  public signout(redirect = true) {
    this.setUserAndToken(null, false, null);
    this.ls?.removeItem(this.URL_API);
    this.ls?.removeItem(this.JWT_TOKEN);
    this.ls?.removeItem(this.APP_USER);
    this.ls?.removeItem(this.JWT_TOKEN_REMOTO);
    this.ls?.clear();
    if(redirect)this.router.navigateByUrl('sessions/signin');
  }

  clear() {
    this.ls.setItem(this.URL_API, environment.apiURL);
    // this.ls.setItem(this.JWT_TOKEN, '');
    // this.ls.setItem(this.JWT_TOKEN_REMOTO, '');
  }

  isLoggedIn(): Boolean {
    return !!this.getJwtToken();
  }

  getJwtToken() {
    return this.ls.getItem(this.JWT_TOKEN);
  }

  getJwtTokenByUrl(url?: string) {
    if (
      this.item$?.value?.remoto &&
      this.item$?.value?.empresaRemota !== null &&
      this.item$?.value?.empresaRemota !== undefined &&
      url !== null &&
      url !== undefined &&
      this.item$?.value?.empresaRemota.urlApi !== null &&
      this.item$?.value?.empresaRemota.urlApi !== undefined &&
      url.search(this.item$?.value?.empresaRemota.urlApi) > -1
    ) {
      return this.getJwtTokenRemoto();
    }
    return this.getJwtToken();
  }

  getJwtTokenRemoto() {
    return this.ls.getItem(this.JWT_TOKEN_REMOTO);
  }

  getUser() {
    return this.ls.getItem(this.APP_USER);
  }

  getUrlApi() {
    return this.ls.getItem(this.URL_API)??environment.apiURL;
  }

  setUser(usuario: Usuario){
    this.ls?.setItem(this.APP_USER, usuario);
  }


  setUserAndToken(item: Item, isAuthenticated: Boolean, itemRemoto: Item) {
    this.isAuthenticated = isAuthenticated;
    
    this.item = item;
    this.item$?.next(item);
    this.token = item?.token;
    this.user = item?.usuario;
    this.user$?.next(item?.usuario);
    this.ls?.setItem(this.JWT_TOKEN, item?.token);
    this.ls?.setItem(this.APP_USER, item?.usuario);
     if (this.item$?.value?.remoto) {
      this.ls.setItem(this.URL_API, this.item$?.value?.empresaRemota.urlApi);
        // this.apiUrl = this.item$?.value?.empresaRemota.urlApi ;
      } else {
        // this.apiUrl = `${environment.apiURL}`;
      }
    // this.ls.setItem(this.URL_API, environment.apiURL);
    if (itemRemoto !== null && itemRemoto !== undefined) {
      this.ls.setItem(this.JWT_TOKEN_REMOTO, itemRemoto.token);
      this.itemRemoto = itemRemoto;
      this.itemRemoto$.next(itemRemoto);
      this.tokenRemoto = itemRemoto.token;
      // Atualizar item$ com cadastroVendedorId de itemRemoto
      const currentItem = this.item$.getValue();
      if (currentItem) {
        const updatedItem = { ...currentItem, cadastroVendedorId: itemRemoto.cadastroVendedorId };
        this.item$.next(updatedItem);
      }
      // this.ls.setItem(this.URL_API, itemRemoto?.empresaRemota?.urlApi ?? environment.apiURL);
    }
    // this.tokenRemoto = this.token || this.getJwtToken();
    // console.log('ITEM EM REQ:' + JSON.stringify(this.jwtAuth.item$?.value) + '\n na CHAMADA' + req.url );

    if (this.item$?.value?.remoto && this.item$?.value?.empresaRemota !== null
      && this.item$?.value?.empresaRemota !== undefined && (this.item$?.value?.empresaRemota?.urlApi??'')!=='') {
                // this.tokenRemoto = (this.getJwtTokenRemoto()??this.getJwtToken());
      // console.log('COLOCANDO TOKEN:' + token + '\n na CHAMADA' + req.url );
    }
  }

  getUsuario(id: number ): Observable<Usuario> {
    return this.http.get<Usuario>(`${this.url + this.path}/?usuarioId=${id}`);
  }

  getUsuarioExist(email: string ): Observable<any> {
    return this.http.get<any>(`${this.url + this.path}/exists?email=${email}`);
  }

  saveOrUpdate( signup: any): Observable<Usuario> {
    return this.http.put<Usuario>(`${this.url + this.path}/manutencao/conta`, signup);
  }

  updateTransacoes(usuarioId: number, transacoesHabilitadas: string): Observable<Usuario> {
    const body = { transacoesHabilitadas };
    return this.http.put<Usuario>(`${this.url + this.path}/transacoes?usuarioId=${usuarioId}`, body);
  }


  createAcces(tokenValidacao: string, usuario: Usuario): Observable<Usuario> {
    return this.http.put<Usuario>(`${this.url + this.path}/create/access?validToken=${tokenValidacao}`, usuario);
  }

  recoveryPass(rec: LoginRequest): Observable<Token> {
    return this.http.put<Token>(`${environment.apiURL}/auth/recovery/pass`, rec);
  }

  changePassword(rec: LoginRequest): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/auth/change/pass`, rec);
  }


  validaAccess(usuario: Usuario): Observable<Usuario> {
    return this.http.put<Usuario>(`${this.url + this.path}/get/token/valida`, usuario);
  }

  recuperaAccess(email: any): Observable<any> {
    return this.http.put<any>(`${this.url + this.path}/get/token/recupera?email=${email}`, email);
  }


  sendPassword(rec: LoginRequest): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/email/change/pass`, rec);
  }

  getEmpresaSelecionada$(): BehaviorSubject<Loja> {
    const lojaAsJson = localStorage.getItem('empresa');
    if (lojaAsJson && lojaAsJson !== undefined && lojaAsJson !== null && lojaAsJson.length > 0) {
      if ( this.subjEmpresaSelecionada$ === undefined  || this.subjEmpresaSelecionada$.getValue() === null ) {
         const loja: Loja = JSON.parse(lojaAsJson);
         this.subjEmpresaSelecionada$.next(loja);
      }
    }
    return this.subjEmpresaSelecionada$;
  }

  setEmpresaSelecionada(loja: Loja) {
    this.subjEmpresaSelecionada$.next(loja);
  }

  getItem(): Observable<Item> {
    return this.item$?.asObservable();
  }
  
  

  // conectaLoja(signup: any): Observable<any> {
  //   console.log('SIGNUP:' + signup);
  //   return this.http.put<string>(`${this.subjLojaSelecionada$?.value?.url_api}/usuario/signup/loja`, signup);
  // }

  setItemLoja(itemLoja: Item) {
    this.subjItemLoja$.next(itemLoja);
  }

  getUsers(page?: number, size?: number,  search?: string): Observable<PageResult<Item>> {
    return this.http.get<PageResult<Item>>(`${environment.apiURL + this.authPath}/user/all/page/get/?page=${page}&size=${size}&search=${search}`);
  }

  getUserPage(page?: number, size?: number, order?: string,
    direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<Item>> {
    return this.http.get<PageResult<Item>>(`${this.apiUrl + this.authPath}/user/list/page/get/?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getUserPageSearch(page?: number, size?: number,
    search?: string, order?: string, direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<Item>> {
    return this.http.get<PageResult<Item>>(`${this.apiUrl + this.authPath}/user/list/page/get/?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getUserList(): Observable<Item[]> {
    return this.http.get<Item[]>(`${this.apiUrl + this.authPath}/user/list/get`);
  }

  toogleLockedRemoto(email: any): Observable<Item> {
    return this.http.put<any>(`${this.apiUrl + this.authPath}/user/locked/toggle/${email}`, email);
  }

  toogleLockedLocal(email: any): Observable<Item> {
    return this.http.put<any>(`${environment.apiURL + this.authPath}/user/locked/toggle/${email}`, email);
  }


  addUser(email: String): Observable<any> {
    return this.http.put<string>(`${environment.apiURL}/auth/user/add/${email}`, null);
  }

  addUserRemoto(signupData: { username: String; password: number; password2: number;  remoteId: number, remoteUrl: string, remoteToken: string, filialId: number }) {
    
    return this.http.put<string>(`${this.apiUrl}/auth/acesso/remoto`, signupData);
  }

  deleteUserRemoto(item: Item): Observable<Item> {
    return this.http.put<Item>(`${this.apiUrl}/auth/user/delete/remoto`, item);
  }

  deleteUser(item: Item): Observable<Item> {
    return this.http.put<Item>(`${environment.apiURL}/auth/user/delete`, item);
  }

  isAuthorized(role: string) {
    return (this.item$?.value?.roles??[]).includes(role);
  }

  isRoleAuthorized(item: Item, role: string) {
    return (item?.roles??[]).includes(role);
  }

  public isRoot() {
    return this.isAuthorized('ROOT');
  }

  changeAuth(item: Item, roleName: string, auth: string) {
    // "/change", params={"roleName", "roleAuth"}
    return this.http.put<Item>(`${this.apiUrl}/role/change?roleName=${roleName}&roleAuth=${auth}`, item);
  }

  getRoles(usuarioId: number) {
    return this.http.get<any[]>(`${this.apiUrl}/auth/user/list/page/get/roles?usuarioId=${usuarioId}`);
  }


  confirmUser(rec: LoginRequest): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/auth/user/confirm`, rec);
  }

}
